module.exports = __webpack_public_path__ + "static/aimInsurance-cfcdbf3a8d45a1555135ddf47ce3ea1c.png";